// vendor
import { format } from "date-fns";
// project
import { formatDateStringRecent, formatDuration } from "@/utils/text";



const formatDateCol = (v:string) => {
	// return format(new Date(v), "eee MMM d y @ HH:mm");
	return format(new Date(v), "MMM d y @ HH:mm");
};

export const columns = [
	{
		key:"name",
		sortable:true,
		thClass:"font-weight-light text-light noselect txt-80",
		tdClass:"align-middle txt-80",
	},
	
	{
		key:"target.study",
		label:"Blueprint @ Version",
		sortable:false,
		thClass:"font-weight-light text-light noselect txt-80",
		tdClass:"align-middle",
	},
	{
		key:"sessions",
		label:"Sessions",
		thClass:"txt-80 font-weight-light noselect mr-2",
		tdClass: "txt-70 align-middle tcol-01",
		class:"text-light",
		sortable:false
	},
	{
		key:"created",
		label:"Created",
		formatter(v?:string){
			return v ? formatDateCol(v) : "-";
		},
		thClass:"txt-80 font-weight-light noselect",
		tdClass: "txt-60 align-middle xl-col",
		class:"text-light",
		sortable:true
	},
	{
		key:"lastVisited",
		label:"Latest Session",
		formatter(v?:string){
			return v ? formatDateCol(v) : "-";
		},
		thClass:"font-weight-light noselect txt-80",
		tdClass: "txt-60 align-middle xl-col",
		class:"text-light",
		sortable:true
	},
	{
		key:"enabled",
		label:"Sharing",
		thClass:"font-weight-light noselect text-light txt-80",
		tdClass: "txt-80 align-middle tcol-01 bg-inxfo",
		class:"text-light",
		sortable:false
	},
	// {
	// 	key:"sharing",
	// 	label:"Sharing",
	// 	thClass:"font-weight-light tcol-xs noselect text-muted txt-80",
	// 	tdClass: "txt-80 align-middle",
	// 	class:"text-light",
	// 	sortable:false
	// },
	{
		key:"controls",
		label:"",
		tdClass:"tcol-01 bg-dangerx",
		class:"text-light",
		sortable:false
	},
];


// {
// 	key:"type",
// 	label: "Type",
// 	sortable:true,
// 	thClass:"lg-cold font-weight-light text-light noselect txt-80",
// 	tdClass:"align-middle pr-3d px-5d txt-80",
// 	// formatter:pascalToSentenceCase
// },